import React, { useEffect, useRef, useImperativeHandle, forwardRef, useCallback } from 'react';
import classnames from 'classnames';
import FJHorizontalScroller from '../../components/FJScroller/FJHorizontalScroller';
import ArrowIcon from '../../../assets/svg/catalog-right.svg?react';
import Style from './FJHorizontalScrollTab.module.less';
import FJTab from './FJTab';
import classNames from 'classnames';

const FJHorizontalScrollTab = (props, ref) => {
    const scroll = useRef();
    const tab = useRef();

    const leftButton = useRef();
    const rightButton = useRef();

    const {
        dataList = [],
        selectedIndex = 0,
        onTabChange,
        arrowClass,
        className,
        selectClassName,
        lineClassName,
        textClassName,
        itemClassName,
        space,
        isGradationBorder = false,
        gradationClassName,
        gradationContentClassName,
        gradationActiveClassName,
    } = props;

    useImperativeHandle(ref, () => {
        return {
            autoLocation: _autoLocation,
            updateArrowState: _updateArrowState,
        };
    });

    useEffect(() => {
        _autoLocation();
    }, [selectedIndex, dataList]);

    useEffect(() => {
        _displayLeftButton(selectedIndex !== 0);
        _displayRightButton(selectedIndex !== dataList.length - 1);
    }, []);
    /**
     * @desc 自动定位到选中的元素上，并居中显示
     * @private
     */
    const _autoLocation = () => {
        if (tab.current && scroll.current) {
            const selectedItemRect = tab.current.getSelectedItemRect();
            if (!selectedItemRect) return;
            const scroller = scroll.current.getScroller();
            const scrollerVisibleWidth = scroller.offsetWidth;
            const scrollWidth = scroller.scrollWidth;
            const { x = 0, width = 0 } = selectedItemRect;
            let centerPoint = x + width / 2 - scrollerVisibleWidth / 2;
            if (centerPoint < 0) centerPoint = 0;
            else if (centerPoint > scrollWidth - scrollerVisibleWidth) centerPoint = scrollWidth - scrollerVisibleWidth;
            scroll.current.scrollToLeft(centerPoint, 'smooth');
        }
    };

    const _onTabChange = index => {
        if (index === selectedIndex) {
            _autoLocation();
        }
        if (onTabChange) onTabChange(index);
    };

    const _updateArrowState = useCallback(() => {
        if (!scroll.current) return;
        const scroller = scroll.current.getScroller();
        const scrollLeft = scroller.scrollLeft;
        const scrollWidth = scroller.scrollWidth;
        const visibleWidth = scroller.offsetWidth;
        const maxScrollLeft = scrollWidth - visibleWidth;

        _displayLeftButton(scrollLeft > 5);
        _displayRightButton(scrollLeft < maxScrollLeft - 5);
    }, []);

    const _displayLeftButton = display => {
        if (leftButton.current) {
            leftButton.current.style.display = display ? 'flex' : 'none';
        }
    };

    const _displayRightButton = display => {
        if (rightButton.current) {
            rightButton.current.style.display = display ? 'flex' : 'none';
        }
    };

    const _moveScroller = direction => {
        if (!scroll.current) return;
        const scroller = scroll.current.getScroller();
        const scrollLeft = scroller.scrollLeft;
        const position = direction === 'left' ? scrollLeft - 200 : scrollLeft + 200;
        scroll.current.scrollToLeft(position, 'smooth');
    };
    const cn = classnames(Style.container, className);
    return (
        <div className={cn}>
            <FJHorizontalScroller ref={scroll} className={Style.scroller} onScroll={_updateArrowState}>
                <FJTab
                    ref={tab}
                    dataList={dataList}
                    selectedIndex={selectedIndex}
                    onChange={_onTabChange}
                    itemClass={classNames(Style.tab_item, itemClassName)}
                    lineClass={lineClassName}
                    selectClassName={selectClassName}
                    textClassName={textClassName}
                    space={space}
                    isGradationBorder={isGradationBorder}
                    gradationClassName={gradationClassName}
                    gradationActiveClassName={gradationActiveClassName}
                    gradationContentClassName={gradationContentClassName}
                />
            </FJHorizontalScroller>
            <div
                ref={leftButton}
                className={classnames(Style.arrow_button, Style.left_arrow, arrowClass)}
                onClick={e => _moveScroller('left')}
            >
                <ArrowIcon />
            </div>
            <div
                ref={rightButton}
                className={classnames(Style.arrow_button, Style.right_arrow, arrowClass)}
                onClick={e => _moveScroller('right')}
            >
                <ArrowIcon />
            </div>
        </div>
    );
};

export default forwardRef(FJHorizontalScrollTab);
